import { Injectable } from '@angular/core';
import {TERMINOLOGY} from "../../../assets/terminology/default";

@Injectable({
  providedIn: 'root'
})
export class TermsService {
  getTerm(key: keyof typeof TERMINOLOGY): string {
    return TERMINOLOGY[key] || `[${key}]`;
  }

  getTermCapitalized(key: keyof typeof TERMINOLOGY): string {
    const term = this.getTerm(key);
    return term.charAt(0).toUpperCase() + term.slice(1);
  }
}
